import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Layout from "../components/Layout";
import { UserCheck } from "lucide-react";

export default function Recruiters() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/recruiters").then(r => setRows(r.data)); }, []);

  return (
    <Layout>
      <div className="mb-6">
        <div className="text-[11px] font-semibold uppercase tracking-widest text-sky-600 mb-1">Recruiters</div>
        <h1 className="font-display text-3xl font-bold text-slate-900 tracking-tight">Recruiter performance</h1>
        <p className="text-sm text-slate-500 mt-1">Attribution, specialization, and pipeline ownership.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {rows.map(r => (
          <div data-testid={`recruiter-card-${r.id}`} key={r.id} className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 rounded-full bg-slate-900 text-white flex items-center justify-center font-display font-semibold">{r.name?.slice(0,1)}</div>
              <div>
                <div className="font-semibold text-slate-900">{r.name}</div>
                <div className="text-xs text-slate-500">{r.specialization}</div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-2 text-xs">
              <div className="bg-slate-50 rounded p-2 border border-slate-100">
                <div className="text-slate-500 uppercase tracking-widest text-[10px]">Candidates</div>
                <div className="text-slate-900 font-mono font-bold text-lg">{r.candidates_owned}</div>
              </div>
              <div className="bg-slate-50 rounded p-2 border border-slate-100">
                <div className="text-slate-500 uppercase tracking-widest text-[10px]">Approved</div>
                <div className="text-emerald-700 font-mono font-bold text-lg">{r.approved_count}</div>
              </div>
            </div>
            <div className="mt-3 text-[11px] text-slate-500 flex items-center gap-1.5"><UserCheck size={11}/> {r.country} · {r.status}</div>
          </div>
        ))}
        {rows.length === 0 && <div className="text-sm text-slate-500 col-span-full">No recruiters yet.</div>}
      </div>
    </Layout>
  );
}
